import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";

import successfulBanner from "../assets/images/Lets-fete-banner.svg";
import mainLogo from "../assets/images/main-logo.svg";


const Successful = () => {
	const { t } = useTranslation();
	return (
		<div className="flex">
      {/* Account Type Left */}
      <div className="w-1/2">
        <div className="bg-[#f9fafb] flex items-center justify-center h-[calc(100vh_-_1px)]">
			<img src={successfulBanner} alt="banner" />
        </div>
      </div>

      {/* Account type right */}
      <div className="w-1/2 flex flex-col">
        {/* Upper Content */}
        <div className="w-full h-[calc(100vh_-_69px)] flex items-center overflow-y-auto customHeight800:pt-8 customHeight700:pt-14">
          <div className="w-full max-w-[384px] mx-auto text-center">
            {/* Logo */}
            <div className="text-center pb-8 pt-0">
              <img className="inline-block" src={mainLogo} alt="logo" />
            </div>

            {/* Content */}
            <div className="w-full px-3">
				<h2 className="text-[#101828] text-2xl font-interSemiBold pb-3 text-center">
				{t("successful.heading")}</h2>
				<p className="text-[#475467] pb-4 text-center">
				{t("successful.subheading")}
				</p>
				<div className="text-center mb-8">
					<span className="border border-[#EAECF0] text-sm font-interMedium text-[#344054] bg-[#F2F4F7] px-2.5 py-2.5 rounded-full mx-auto block">
						{t("successful.ready")}
					<span className="text-sm text-[#067647] font-interMedium border border-[#ABEFC6] rounded-full bg-[#fff] px-3 py-1 ml-1">Events@Nike</span>
					</span>
				</div>
				<button className="submit-btn-blue w-full">Continue</button>
            </div>
          </div>
        </div>
		<Footer />
      </div>
    </div>
	);
  };
  
  export default Successful;